export default {
  patient: {
    firstName: '名字',
    lastName: '姓',
    medications: {
      label: '药物治疗',
      new: '添加新药',
      warning: {
        noMedications: '没有药物',
      },
      noMedicationsMessage: '没有药物要求此人。',
    },
  },
}
